import { render, staticRenderFns } from "./ShowProduct.vue?vue&type=template&id=b0fce92c&scoped=true&"
import script from "./ShowProduct.vue?vue&type=script&lang=js&"
export * from "./ShowProduct.vue?vue&type=script&lang=js&"
import style0 from "./ShowProduct.vue?vue&type=style&index=0&id=b0fce92c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fce92c",
  null
  
)

export default component.exports